/**
 * @description Returns the count for the given view adjusted by any realtime
 * updates that may have occurred.
 */
export function getRealtimeViewCount(viewId, threadCount, countOffsets) {
  if (threadCount === null) return null;
  const countOffset = countOffsets.get(viewId, 0);
  return Math.max(threadCount + countOffset, 0);
}